export const skillsData = [
    {
        title: "Backend",
        skills: [
            { name: "Java & Spring Boot", level: "Daily use" },
            { name: "Oracle SQL", level: "Daily use" },
            { name: "Spring Security", level: "Auth & access control" },
            { name: "Spring Cloud (Zuul)", level: "Gateway & routing" },
            { name: "REST & OpenAPI 3.0", level: "API design" },
            { name: "JPA, Maven & Gradle", level: "Persistence & builds" },
            { name: "PostgreSQL & MySQL", level: "Incl. replication" },
            { name: "Elasticsearch", level: "Search" },
        ],
    },
    {
        title: "Integrations & Security",
        skills: [
            { name: "Third-party APIs", level: "Incl. payment gateways" },
            { name: "Digital wallets & cards", level: "Tokenization" },
            { name: "RabbitMQ", level: "Reliable messaging" },
            { name: "OAuth2, JWT & LDAP", level: "Authentication" },
            { name: "Encryption & secure tokens", level: "Data protection" },
            { name: "API security reviews", level: "Docs & prep" },
        ],
    },
    {
        title: "DevOps & Code Quality",
        skills: [
            { name: "Bash scripting", level: "Daily automation" },
            { name: "SonarQube", level: "Quality gates & standards" },
            { name: "Docker & Kubernetes", level: "Containers" },
            { name: "Git & SVN", level: "Version control" },
        ],
    },
    {
        title: "Also Familiar With",
        skills: [
            { name: "React & TypeScript", level: "Basic, side projects" },
            { name: "React Native", level: "Basic, side projects" },
            { name: "C# / WPF", level: "Small desktop tools" },
            { name: "Python", level: "Build scripts" },
        ],
    },
];
